
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexHVp17Vauy3cRa04ioSo9mRwo4CzcHqx4_rsAqWWEw9QMeta } from "/tmp/tmpp66lxhdn/pages/[area]/[pref]/[id]/index.vue?macro=true";
import { default as indexh_45smGeNOexCOlYLVnDjW8k_45Vzmrt4pfodQZ2oXo2J_458Meta } from "/tmp/tmpp66lxhdn/pages/[area]/[pref]/index.vue?macro=true";
import { default as index7NMLD6wv9TmcE_459d0URIg5RA7D9t6XQZocEisvy0fNwMeta } from "/tmp/tmpp66lxhdn/pages/[area]/index.vue?macro=true";
import { default as indexnWWa4Vawg4kSGmCjoYX2iS1xy7lkjOrWI_45UrQ63nXPoMeta } from "/tmp/tmpp66lxhdn/pages/index.vue?macro=true";
import { default as indexa7OsjZGuwZnfoIAoW4ccqHT1omYXJp38fA1lCXWKp1YMeta } from "/tmp/tmpp66lxhdn/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexTN9vfxw_rgzzzR8uQSzgKPFSnkrX2fI9XzeBVClU32MMeta } from "/tmp/tmpp66lxhdn/pages/okinawa/index.vue?macro=true";
import { default as indexJ3ybQkDPTTcJPJkpbFqhcVAx7IFpiECUo0THBWdIoGcMeta } from "/tmp/tmpp66lxhdn/pages/zoom-map/index.vue?macro=true";
export default [
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmpp66lxhdn/pages/[area]/[pref]/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmpp66lxhdn/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmpp66lxhdn/pages/[area]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpp66lxhdn/pages/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmpp66lxhdn/pages/okinawa/[id]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmpp66lxhdn/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmpp66lxhdn/pages/zoom-map/index.vue")
  }
]